export default "__VITE_ASSET__CnsFzqGw__"